<template>
  <VAlert
    v-if="show"
    :class="{
      'no-border': noBorder,
      'xs': xs,
      'small': small,
      'medium': medium,
      'large': large
    }"
    variant="outlined"
    :rounded="false"
    color="error"
    class="error-container-alert"
    :data-testid="dataTestid"
  >
    <h3
      v-if="header"
      class="my-2 text-error"
    >
      {{ header }}
    </h3>
    <div
      v-for="(eMessage, index) in errorMessages"
      :key="index"
      :class="{'my-1':header}"
      data-testid="test-message"
    >
      {{ eMessage }}
    </div>
    <!-- eslint-disable vue/no-v-html -->
    <span
      v-if="errorLink"
      v-html="errorLink"
    />
    <!-- eslint-enable vue/no-v-html -->
  </VAlert>
</template>

<script lang="ts" setup>

interface Props {
 header?: string | null
 message?: string | null
 messages?: string[]
 noBorder?: boolean
 xs?: boolean
 small?: boolean
 medium?: boolean
 large?: boolean
 errorLink?: string
 dataTestid?: string
}

const props = withDefaults(defineProps<Props>(), {
  header: undefined,
  message: undefined,
  messages: () => [],
  noBorder: false,
  xs: false,
  small: false,
  medium: false,
  large: false,
  errorLink: undefined,
  dataTestid: 'error-container-alert'
})

const errorMessages = computed(() => [...props.messages, props.message ?? ''].filter(m => m && m !== ''))
const show = computed(() => {
  // functionality chnage to only show the container if a messages is explicitly passed in
  return ((errorMessages.value && errorMessages.value.length > 0 && !!errorMessages.value[0]) || !!props.errorLink)
})
</script>

<style lang="scss" scoped>
  .error-container-alert {
    margin-bottom: 12px;
    &.no-border {
      border: transparent;
    }
    &.small {
      font-size: 0.86rem;
      :deep(.v-icon) {
        font-size: 1rem;
        margin-right: 0px;
      }
    }
    &.medium {
      font-size: 1rem;
      :deep(.v-icon) {
        height: 18px;
        font-size: 18px;
        margin-right: 4px;
      }
    }
    &.large {
      font-size: 1rem;
      :deep(.v-icon) {
        font-size: 36px;
        margin-top: 12px;
      }
    }
  }
</style>
